import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { setupApi, type LocationCredentialsInput } from '../api/setupApi';
import { setupKeys } from '../queryKeys';

export function useInsuranceCredentials() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: setupKeys.credentials(locationId),
    queryFn: () => setupApi.getLocationCredentials(locationId),
    enabled: !!locationId,
  });

  const save = useMutation({
    mutationFn: (input: Omit<LocationCredentialsInput, 'locationId'>) =>
      setupApi.saveLocationCredentials({ ...input, locationId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: setupKeys.credentials(locationId) });
      queryClient.invalidateQueries({ queryKey: setupKeys.readiness(locationId) });
    },
  });

  return { ...query, credentials: query.data ?? null, save, locationId };
}
